<div class="block form-admin" [loading]="loading">
  <header class="header-admin">
    <h1 class="admin">{{admin ? 'Les commandes' : 'Mes commandes'}}</h1>
  </header>

  <gob-order-filter (search)="filter=$event" [admin]="admin"></gob-order-filter>

  <div class="list-container">
    <div class="table-responsive">
      <table class="table mobile-optimised">
        <thead>
          <tr>
            <th scope="col">Numéro</th>
            <th scope="col">Date</th>
            <th scope="col">Client</th>
            <th scope="col">Montant</th>
            <th scope="col">Livraison</th>
            <th scope="col">Contenu</th>
            <th scope="col">Etat</th>
            <th scope="col" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody class="table-group-divider">
          <tr *ngFor="let order of orders">
            <td data-label="Numéro" class="fw-bold">{{order.ident}}</td>
            <td data-label="Date">{{order.dateCreate | date:'dd/MM/yyyy'}}</td>
            <td data-label="Client">{{order.customer}}</td>
            <td data-label="Montant">{{order.amountTTC | formatPrice}}€</td>
            <td data-label="Livraison">{{getShop(order)}}</td>
            <td data-label="Contenu" *ngIf="order.transactions">
              <div class="order-items">
                <p *ngFor="let transaction of order.transactions" class="mb-1">
                  <ng-container *ngIf="!transaction.name.toLowerCase().includes('emballage')">
                    <span class="qty">{{transaction.qte}} x</span>
                    <a [routerLink]="route.parse('product', [transaction.product])" class="product-link">
                      {{ transaction.name.length > 25 ? (transaction.name | slice:0:25) + '...' : transaction.name }}
                    </a>
                    <i *ngIf="transaction.giftWrapping === 'true'" class="fa-sharp fa-solid fa-gift"></i>
                  </ng-container>
                </p>
              </div>
            </td>
            <td data-label="Etat">
              <span class="badge-state">{{getState(order) | titlecase}}</span>
            </td>
            <td data-label="Actions" class="text-end">
              <a *ngIf="admin" [routerLink]="route.parse('order-set', [order.ident])" [queryParams]="{admin: admin}" class="btn-action">
                <i class="green fa-solid fa-pen-to-square"></i>
              </a>
              <a *ngIf="!admin" [routerLink]="route.parse('order-set', [order.ident])" [queryParams]="{admin: admin}" class="btn-action">
                <i class="green fa-solid fa-eye"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <gob-pagination (change)="search($event)" [activePage]="page" [max]="max"></gob-pagination>
  </div>
</div>